import React from "react";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";

import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import BlockHeading from "../sections/BlockHeading";
import GreenBlockSection from "../sections/GreenBlockSection";
import CoverFlowGallery from "../sections/CoverFlowGallery";

const styles = {
  enquiryButton: {
    marginTop: 10,
    width: 260,
    maxWidth: "100%",
    textTransform: "none",
  },
};

const GALLERY_IMAGES = [
  { src: "/images/spa/spa-01.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-02.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-03.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-04.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-05.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-06.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-07.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-08.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-09.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-10.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-11.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-12.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-13.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-14.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-15.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-16.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-17.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
  { src: "/images/spa/spa-18.jpg", alt: "Shepstone Spa at Shepstone Gardens" },
];

const ShepstoneSpa = () => {
  return (
    <div>
      <Helmet>
        <title>Shepstone Spa | The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"Discover Shepstone Spa – a serene retreat in the heart of Shepstone Gardens. Experience luxury massages, rejuvenating facials, and holistic wellness treatments designed to restore balance, beauty, and calm."}
        ></meta>
      </Helmet>

      <Header
        bgImg={"/images/spa/spa-01.jpg"}
        headText={"SHEPSTONE SPA"}
      />

      <LineSeparator noLine />
      <LineSeparator noLine />

      <GreenBlockSection
        headText={"Shepstone Spa"}
        subHeadText={"Welcome to"}
      >
        <div className={"three-columns"}>
          <p className={"venue-intro-text"}>
            Born from the timeless beauty of Shepstone Gardens, Shepstone Spa is a natural extension of our legacy of elegance and care. Where the gardens offer celebration, the spa offers sanctuary, a serene space to slow down, breathe deeply, and press pause.
          </p>
          <p className={"venue-intro-text"}>
            Every detail has been thoughtfully curated, from our boho chic surroundings to our carefully selected therapists and natural treatments. Whether you are preparing for a wedding, enjoying time with loved ones, or seeking a quiet moment just for yourself, Shepstone Spa is designed to restore balance and renew your spirit.
          </p>
          <p className={"venue-intro-text"}>
            Here, luxury is not just about beauty, it’s about well-being. At Shepstone Spa, leave feeling lighter, calmer, and beautifully renewed.
          </p>
        </div>
      </GreenBlockSection>

      <LineSeparator noLine />
      <LineSeparator noLine />
      <LineSeparator />
      <BlockHeading
        headText={"The Pyjama Lounge"}
        noBorder
      />
      <p
        className={"venue-intro-text standard-width"}
        style={{ textAlign: "center" }}
      >
        Step into a space where joy, luxury, and unforgettable memories come together. Our exclusive Pyjama Lounge is the perfect setting for your precious moments and celebrations — a cozy yet glamorous haven designed to make your special day truly extraordinary. The Pyjama Lounge is more than a place to unwind — it’s a backdrop for moments you’ll cherish forever.
      </p>

      <CoverFlowGallery
        images={GALLERY_IMAGES}
        noOvButton
      />

      <LineSeparator />
      <BlockHeading
        headText={"Interested in celebrating at Shepstone Spa?"}
        noBorder
      />
      <p
        className={"venue-intro-text"}
        style={{ textAlign: "center" }}
      >
        For bookings and celebration enquiries, please get in touch with the Shepstone Spa team.
      </p>
      <div style={{ textAlign: "center" }}>
        <Button
          href={"mailto:info@shepstonespa.co.za"}
          variant={"contained"}
          color={"secondary"}
          style={styles.enquiryButton}
        >
          info@shepstonespa.co.za
        </Button>
        <br />
        <Button
          href={"https://www.shepstonespa.co.za/"}
          target={"_blank"}
          rel={"noopener noreferrer"}
          variant={"outlined"}
          color={"secondary"}
          style={styles.enquiryButton}
        >
          Visit shepstonespa.co.za
        </Button>
      </div>

      <LineSeparator noLine />
    </div>
  );
};

export default ShepstoneSpa;
